import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}

(() => {
  const footerUtilitiesId = 'shopify-section-sections--20143680421953__footer_utilities_jLGE8U';
  const legacyNewsletterId = 'shopify-section-sections--20143680421953__footer_m9NzUG';

  async function refreshMaxDecalsFooter() {
    const footerUtilities = document.getElementById(footerUtilitiesId);
    if (!footerUtilities || footerUtilities.querySelector('.maxdecals-footer-directory')) return;

    const legacyNewsletter = document.getElementById(legacyNewsletterId);
    if (legacyNewsletter) legacyNewsletter.style.display = 'none';

    try {
      const response = await fetch('/?section_id=sections--20143680421953__footer_utilities_jLGE8U', {
        credentials: 'same-origin',
      });
      if (!response.ok) return;

      const html = await response.text();
      if (!html.includes('maxdecals-footer-directory')) return;

      const template = document.createElement('template');
      template.innerHTML = html.trim();
      const refreshedFooter = template.content.firstElementChild;
      if (refreshedFooter) footerUtilities.replaceWith(refreshedFooter);
    } catch (error) {
      console.warn('MaxDecals footer refresh skipped', error);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshMaxDecalsFooter, { once: true });
  } else {
    refreshMaxDecalsFooter();
  }
})();
